module.exports = __webpack_public_path__ + "img/btn@2x.75529817.png";